import * as React from "react";

const LOGO = "/site-img/logo.svg?v=2";
const SITE_URL = "https://www.erevolutionsindia.com/";
const BRAND_BLUE = "#1d4ed8";
const BRAND_ORANGE = "#f97316";

export function ERevolutionsWordmark({ size }) {
  const fontSize = size === "sm" ? "1.1rem" : size === "lg" ? "1.5rem" : "1.35rem";
  return (
    <span
      className="erev-wordmark"
      style={{
        fontSize,
        fontWeight: 600,
        letterSpacing: "-0.025em",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ color: BRAND_BLUE }}>eRevolu</span>
      <span style={{ color: BRAND_ORANGE }}>tions</span>
    </span>
  );
}

export function ERevolutionsBrand({ href = "/" }) {
  return (
    <a
      href={href}
      className="erev-brand"
      style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
    >
      <img
        src={LOGO}
        alt="Trades Algo by eRevolutions"
        className="erev-brand-logo"
        style={{ height: 48, width: "auto", display: "block", flexShrink: 0 }}
      />
    </a>
  );
}

export function ERevolutionsFooterNote() {
  return (
    <span>
      Trading automation by{" "}
      <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
        eRevolutions India
      </a>
      {" · "}Trades Algo
    </span>
  );
}

export { SITE_URL, LOGO, BRAND_BLUE, BRAND_ORANGE };
